import DeliveryHasCancellation from "../symbols/deliveryHasCancellation";
import { HttpRequestGet } from "../../service";
const deliveryHasCancellationAction = () => ({
  type: DeliveryHasCancellation.DELIVERY_HAS_CANCELLATION,
});
const deliveryHasCancellationSuccessAction = (data: any) => ({
  type: DeliveryHasCancellation.DELIVERY_HAS_CANCELLATION_SUCCESS,
  payload: data,
});
const deliveryHasCancellationFailureAction = (data: any) => ({
  type: DeliveryHasCancellation.DELIVERY_HAS_CANCELLATION_FAILURE,
  payload: data,
});
const clearDeliveryHasCancellationAction = () => ({
  type: DeliveryHasCancellation.CLEAR_DELIVERY_HAS_CANCELLATION,
});

export function getDeliveryHasCancellation(id: string) {
  const url = `/customer/delivery/${id}/has-cancellation`;
  return (dispatch: any) => {
    dispatch(deliveryHasCancellationAction());
    HttpRequestGet(
      url,
      dispatch,
      deliveryHasCancellationSuccessAction,
      deliveryHasCancellationFailureAction,
      true
    );
  };
}

export function clearDeliveryHasCancellation() {
  return (dispatch: any) => {
    dispatch(clearDeliveryHasCancellationAction());
  };
}
